import { useTypedSelector } from './useTypedSelector'

export const useTheme = () => {
    const { theme } = useTypedSelector((state) => state.theme)

    return theme
}
